import { Link as MLink, LinkProps } from '@material-ui/core'
import { GatsbyLinkProps, Link } from 'gatsby'
import React from 'react'

export default function GaLink(
  props: LinkProps & GatsbyLinkProps<any> & { ref?: any }
): JSX.Element {
  return <MLink component={Link} {...props}></MLink>
}
